var map = {
	"./adult/nn/4 1 Skrivehastighet Intro.mp3": 648,
	"./adult/no/4 1 Skrivehastighet Intro.mp3": 649,
	"./youth/de/4 1 Skrivehastighet Intro.mp3": 650,
	"./youth/nn/4 1 Skrivehastighet Intro.mp3": 651,
	"./youth/no/4 1 Skrivehastighet Intro.mp3": 652,
	"./youth/se/4 1 Skrivehastighet Intro.mp3": 653
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 647;